var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTilesViewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 22 16",
    style: {
      enableBackground: "new 0 0 22 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t    .grid-icon-st0{fill:currentColor;}\n    ")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "grid-icon-st0",
    d: "M0.833984 7.29175H6.87565V0.041748H0.833984V7.29175ZM0.833984 15.7501H6.87565V8.50008H0.833984V15.7501ZM8.08398 15.7501H14.1257V8.50008H8.08398V15.7501ZM15.334 15.7501H21.3757V8.50008H15.334V15.7501ZM8.08398 7.29175H14.1257V0.041748H8.08398V7.29175ZM15.334 0.041748V7.29175H21.3757V0.041748H15.334Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTilesViewIcon);
export default __webpack_public_path__ + "static/media/tiles-view-icon.382f2d65d71bdd60b5be3c3ca9a4f9db.svg";
export { ForwardRef as ReactComponent };